var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "readyExamOnline" },
    [
      _c("el-card", { staticClass: "box-card" }, [
        _c("div", {
          staticClass: "cardTitle",
          domProps: { innerHTML: _vm._s(_vm.titleText) },
        }),
        _vm._v(" "),
        _vm.dateRange
          ? _c("div", { staticClass: "dateRangeStyle" }, [
              _vm._v(_vm._s(_vm.dateRange)),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "btnGroup" },
          [
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.signUpBtnShow,
                    expression: "signUpBtnShow",
                  },
                ],
                staticStyle: { margin: "0 10px" },
                attrs: { type: "primary" },
                on: { click: _vm.signUpExam },
              },
              [_vm._v("报名")]
            ),
            _vm._v(" "),
            _c(
              "el-button",
              {
                directives: [
                  {
                    name: "show",
                    rawName: "v-show",
                    value: _vm.beginBtnShow,
                    expression: "beginBtnShow",
                  },
                ],
                staticStyle: { margin: "0 10px" },
                attrs: { type: "primary" },
                on: { click: _vm.beginExam },
              },
              [_vm._v(_vm._s(_vm.btnText))]
            ),
            _vm._v(" "),
            _vm.showSignUpAlready
              ? _c(
                  "el-tag",
                  { attrs: { type: "info", "disable-transitions": "" } },
                  [_vm._v("已报名")]
                )
              : _vm._e(),
          ],
          1
        ),
      ]),
      _vm._v(" "),
      _c("Login"),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/loaders/templateLoader.js??ref--1!./node_modules/vue-loader/lib??vue-loader-options!./src/views/exam/readyExam.vue?vue&type=template&id=9d81abe8&
// module id = null
// module chunks = 